module.exports = __webpack_public_path__ + "static/media/floorIdLogo.2af5d693.svg";